module.exports = __webpack_public_path__ + "static/media/Jubel-Bold.40987058.woff";